import get from "lodash.get";
import { REQUEST_ERROR_502, REQUEST_ERROR_503, UNKNOWN_ERROR, NO_INTERNET_CONNECTION } from "@/App/store/Messages";
import { AxiosError } from "axios";
import { StatusCodes } from "http-status-codes";

export const HttpErrorParser = {
  parse: (axiosError: AxiosError) => {
    if (axiosError.response) {
      const errorMessageFromServer = get(axiosError, "response.data.message");
      if (errorMessageFromServer) {
        return errorMessageFromServer;
      } else {
        let message;
        switch (axiosError.response.status) {
          case StatusCodes.BAD_GATEWAY:
            message = REQUEST_ERROR_502;
            break;
          case StatusCodes.SERVICE_UNAVAILABLE:
            message = REQUEST_ERROR_503;
            break;
          default:
            message = UNKNOWN_ERROR;
        }
        return message;
      }
    } else {
      return NO_INTERNET_CONNECTION;
    }
  },
};
